import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'settings-details-update',
  path: () => '/settings/details',
  type: 'private',
}

export default ROUTE
